import cx from 'classnames';

import './loading.styles.scss';

export const Loading = (props) => {
	const { className, size = 10, margin } = props;

	return (
		<div style={{ width: size, height: size, margin }} className={cx('Loading', className)} />
	);
};